/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pitch_Rules_TitleInputs */



/**
* | output |
* | --- |
* | "Rules first" |
*
* @param {Pitch_Rules_TitleInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const pitch_rules_title = /** @type {((inputs?: Pitch_Rules_TitleInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pitch_Rules_TitleInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Rules first")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Regler först")
	return /** @type {LocalizedString} */ ("Regler først")
});